import styles from "./StockRemovalReview.module.scss";
import { defaultDateDisplay } from "../../../../../helpers";

export const StockRemovalDetailsCard = ({
  removalDetails = {},
  className = "",
  style,
}) => {
  return (
    <div
      className={`${styles.stockRemovalReview__card} ${className}`.trim()}
      style={style}
    >
      <div>
        <h6>Store / Location</h6>
        <p>{removalDetails?.store?.name || "-"}</p>
      </div>

      <div>
        <h6>Created By</h6>
        <p>{removalDetails?.created_by?.first_name || "-"}</p>
      </div>

      <div>
        <h6>Submitted By</h6>
        <p>
          {removalDetails?.submitted_by?.first_name ||
            removalDetails?.created_by?.first_name ||
            "-"}
        </p>
      </div>

      <div>
        <h6>Date Submitted</h6>
        <p>
          {defaultDateDisplay(
            removalDetails?.submitted_at || removalDetails?.created_at,
          )}
        </p>
      </div>

      <div>
        <h6>Reviewed By</h6>
        <p>{removalDetails?.reviewed_by?.first_name || "-"}</p>
      </div>

      <div>
        <h6>Review Date</h6>
        <p>{defaultDateDisplay(removalDetails?.reviewed_at)}</p>
      </div>

      <div>
        <h6>Total Items</h6>
        <p>{removalDetails?.items?.length || 0}</p>
      </div>

      <div>
        <h6>Remarks</h6>
        <p>{removalDetails?.remarks || "-"}</p>
      </div>
    </div>
  );
};

export { StockRemovalDetailsCard as StockRemovalReviewDetails };
export default StockRemovalDetailsCard;
